export default {
    setDisputas(state, d) {
        state.disputas = d
    }
}